
export const handleNavSections = function () {

    // Go to sticky navbar section links
    $("a").on('click', function(event) {

        if ( this.hash !== "" ) {
            event.preventDefault();

            var hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                window.location.hash = hash;
            });
        } 

    });


    // Go to document url section link
    var hash_url = window.location.hash;

    if ( hash_url !== "" ) {

        $('html, body').animate( {

            scrollTop: $( hash_url ).offset().top

        }, 800, function(){

            window.location.hash = hash_url;
        });

    }


}
